import gql from 'graphql-tag'

export default gql`
mutation ($_id: MongoID!   ){
  removeForum(_id:$_id){
        recordId
      }
}
`